import { updateQuery } from './query-actions.js';
import { queryReducer as query } from './query-slice.js';
/**
 * Loads the commerce query reducer and returns possible query action creators.
 *
 * @param engine - The headless commerce engine.
 * @returns An object holding the query action creators.
 *
 * @group Actions
 * @category Query
 */
export function loadQueryActions(engine) {
    engine.addReducers({ query });
    return {
        updateQuery,
    };
}
